import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconGame$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconGame extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'e07b247a59befa4dc5ce71c80e857f226717a4d0', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'afa4579b688448a11f3ebde6412d1f7afdc64897', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'b778046d9c41de3dd34cf10124b050dfd805ccb0', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M9.631 14.511H13.5c.696 1.93 1.83 2.989 3.522 2.989 1.194 0 2.242-.43 2.897-1.371.655-.94.764-2.16.287-3.202l-1.99-5.183C17.748 6.056 16.308 5 14.436 5H8.564c-1.762 0-3.313 1.056-3.78 2.744l-1.99 5.183a3.24 3.24 0 0 0 .286 3.202c.655.94 1.703 1.371 2.897 1.371 1.691 0 2.957-1.058 3.653-2.989m-3.694 1.452a1.69 1.69 0 0 1-1.605-.691c-.367-.51-.367-1.167-.145-1.745l1.99-5.279c.449-1.19 1.323-1.725 2.388-1.725h5.87c1.085 0 1.976.53 2.388 1.725l1.99 5.279a1.71 1.71 0 0 1-.158 1.763 1.7 1.7 0 0 1-1.633.673c-.793-.058-1.297-.516-1.72-1.348l-.658-1.344a.49.49 0 0 0-.445-.271H8.944c-.19 0-.363.1-.445.271l-.73 1.476a2.07 2.07 0 0 1-1.832 1.216m9.573-7.459-.502-.5a.258.258 0 0 0-.421 0l-.582.58-.582-.58a.258.258 0 0 0-.421 0l-.502.5a.262.262 0 0 0 0 .42l.582.58-.582.58a.262.262 0 0 0 0 .42l.502.5a.264.264 0 0 0 .421 0l.582-.58.582.58a.258.258 0 0 0 .421 0l.502-.5a.262.262 0 0 0 0-.42l-.582-.58.582-.58a.262.262 0 0 0 0-.42M10.5 9.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-game", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-game"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-game":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconGame$1);
            }
            break;
    } });
}

const CosmosIconGame = CosmosIconGame$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconGame, defineCustomElement };
